import React from 'react'
import { Row, Col } from "react-bootstrap";
import { checkArray } from '../helpers/util';
import { inscriptionHeading } from '../helpers/inscriptionUtils';

export default class DetailElementStylistic extends React.Component {
	
  	render() {
		const inschriften = this.props.inschriften || [];
    	return (<div>
	        {checkArray(this.props.value) ? 
      			<Row >
					<Col md={3} style={{backgroundColor: '#ffffff'}}>
						<strong>{this.props.name}</strong>
       				</Col>
					<Col  md="auto" style={{backgroundColor: '#ffffff'}}></Col>
					<Col md={{ span: 10, offset: 1 }} style={{backgroundColor: '#fbfbfb'}}>
						{this.props.value.map((entry, id) => {
							const block = inschriften.find(item => item && item.id === entry.inschriftId);
							const location = block ? inscriptionHeading(block) : "";
							return (<div key={id}>{location ? location + ", " : ""}Zeile {entry.line}: {entry.comment}</div>);
						})}
       				</Col>
      		</Row>
			: ""}</div>
			
    )
  }
}
